module.exports = __webpack_public_path__ + "static/media/4.04ecf77b.jpg";